'use no memo'

import {
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@repo/ui/components'
import { Column, Table } from '@tanstack/react-table'
import { Settings2Icon } from 'lucide-react'

type ColumnControlsProps<TData> = {
  table: Table<TData>
}

export function ColumnControls<TData>(props: ColumnControlsProps<TData>) {
  const isHiddenInColumnsMenu = (column: Column<TData>) => !column.columnDef.meta?.hideInColumnsMenu
  const visibleColumns = props.table.getAllColumns().filter(isHiddenInColumnsMenu)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" size="icon">
          <Settings2Icon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" collisionPadding={12}>
        {/*
          Scrolls instead of running off the screen. Radix measures the gap between the trigger and
          the viewport edge into this variable; the 0.5rem is the content's own `p-1`, without which
          the list is exactly that much too tall. The blocked-orders cockpit is what exposed this —
          26 columns is well past what fits under a toolbar.

          The cap is on this inner element rather than on the content, whose `overflow-hidden` keeps
          the rounded corners and would otherwise fight an `overflow-y-auto` on the same box.
        */}
        <div className="max-h-[calc(var(--radix-dropdown-menu-content-available-height)_-_0.5rem)] overflow-y-auto">
          {visibleColumns.map((column) => (
            <DropdownMenuCheckboxItem
              key={column.id}
              checked={column.getIsVisible()}
              onCheckedChange={(value) => column.toggleVisibility(!!value)}
              disabled={!column.getCanHide()}
            >
              {column.columnDef.meta?.displayTitle}
            </DropdownMenuCheckboxItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
